const VERSION_URL = "/version.json";
const STORAGE_KEY = "appVersion";

async function fetchLatestVersion() {
  try {
    const response = await fetch(VERSION_URL, { cache: "no-store" });
    if (!response.ok) return null;
    const data = await response.json();
    if (!data) return null;
    return data.version || data.build || null;
  } catch (error) {
    return null;
  }
}

export function startVersionPolling({ intervalMs = 60000 } = {}) {
  let currentVersion = localStorage.getItem(STORAGE_KEY);
  let checking = false;

  const check = async () => {
    if (checking) return;
    checking = true;
    try {
      const latest = await fetchLatestVersion();
      if (!latest) return;
      if (!currentVersion) {
        currentVersion = latest;
        localStorage.setItem(STORAGE_KEY, latest);
        return;
      }
      if (latest !== currentVersion) {
        localStorage.setItem(STORAGE_KEY, latest);
        window.location.reload(true);
      }
    } finally {
      checking = false;
    }
  };

  check();
  setInterval(check, intervalMs);
  window.addEventListener("focus", check);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      check();
    }
  });
}
